<div class="square-container" *ngIf="project">
  <div class="zoom-control-container"
       [ngStyle]="{'width': previewPosition.w, 'height': previewPosition.h,
                       'top': previewPosition.t, 'left': previewPosition.l}">
    <button (click)="openZoomDialog()"
            mat-mini-fab color="tertiary">
      <mat-icon svgIcon="magnify-plus"></mat-icon>
    </button>
  </div>
  <div class="container" id="container" #container *ngIf="!project.design || project.openings.length > 0 || project.vgrooves.length > 0"
       [ngClass]="{'simple-mode': simpleMode || editingVGroove, 'have-frame': project.moulding,
                    'show-rotation-restriction-mode': showRotationRestrictions,
                    'frame-builder': project.primaryProduct == 'FRAME'}">
    <div class="no-frame" *ngIf="initialized && !project.moulding" (click)="requestEdit($event,'moulding')"
         [ngClass]="{sm: project.size.width > project.size.height, 'dim': editingVGroove}"
         [ngStyle]="{'width': previewPosition.w, 'height': previewPosition.h,
                       'top': previewPosition.t, 'left': previewPosition.l}">
    </div>
    <div class="size frame" *ngIf="initialized"
         [ngClass]="{'dim': editingVGroove}"
         [ngStyle]="{'width': previewPosition.w, 'height': previewPosition.h,
                       'top': previewPosition.t, 'left': previewPosition.l,
                       'background-size': '100% 100%'}"
         (click)="requestEdit($event,'moulding')">
      <img *ngIf="project && project.canPreview" [src]="project.url(roundPreviewSize(container.clientWidth??500))" [alt]="project.seoData.metaDescription" />
      <div class="size outer"
           [ngStyle]="{'width': outerPosition.w, 'height': outerPosition.h,
                       'top': outerPosition.t, 'left': outerPosition.l}"
           [style.border]="project.moulding ? 'none' : null"
           (click)="project.primaryProduct === 'MAT' || project.topMat ? requestEdit($event,'topMat') : stopProp($event)">

        @for (opening of openingsWithPosition; track opening; let idx = $index) {
        <div class="size opening" [ngStyle]="{'width': opening.position.w,
                                              'height': opening.position.h,
                                              'top': opening.position.t,
                                              'left': opening.position.l,
                                              'transform': 'rotate(' + opening.rotation + 'deg)'}"
             [ngClass]="{'full-back': opening.reveal === 0 && project.numMats > 1,
                         'oval-shadow': !project.anyOpeningShapeRequiresShadow && opening.shape.length === 1 && opening.shape[0].code === 'oval',
                         'rect-shadow': !project.anyOpeningShapeRequiresShadow && project.numMats === 0 && opening.shape[0].code == 'rect',
                         'never-hide': editingVGroove,
                         'has-fill': project.hasPrint || opening.fill !== 'none', 'fake': project.numOpenings === 0}"
                         (click)="stopProp($event)">

          <!-- allows clicks that are on the opening but not the exact path to be considered  ok to click -->
          <svg id="click-pass-thru" *ngIf="opening.shape[0].code.startsWith('path-')" attr.viewBox="0 0 {{opening.size.width}} {{opening.size.height}}">
            <path (click)="stopProp($event)" [attr.d]="opening.shape[0].code.substr(5)" fill="#ffffff" fill-opacity="0.01"></path>
          </svg>

          <div class="opening-size-label" *ngIf="opening.restrictions?.positionLocked" [ngStyle]="{'top': opening.position.b}">
            {{ opening.size | size | inches }}
          </div>
          <div class="v-groove-container" *ngIf="project.allowVGroove && !project.permanentDesignId && project.numOpenings === 1 && !opening.restrictions?.vGrooveLocked"
               [ngClass]="{'fake-vgroove': project.vGrooveOffset > 0 && !project.topMat}"
               [ngStyle]="{'width': opening.vGroovePosition.w,
                            'height': opening.vGroovePosition.h,
                            'top': opening.vGroovePosition.t,
                            'left': opening.vGroovePosition.l,
                            'transform': 'rotate(' + opening.rotation + 'deg)'}">
            <div class="v-groove" *ngIf="!editingVGroove"
                 [ngClass]="{'dashed': project.vGrooveOffset == 0, 'contrast': !project.topMat}">
              <div class="v-groove-border-background" *ngIf="project.vGrooveOffset === 0"></div>
              <button class="bottom-right extra-small" color="tertiary" mat-mini-fab
                      (click)="vGroove()">
                <mat-icon *ngIf="project.vGrooveOffset === 0" svgIcon="plus"></mat-icon>
                <mat-icon *ngIf="project.vGrooveOffset !== 0 && !editingVGroove" svgIcon="pencil"></mat-icon>
              </button>
            </div>
            <div class="zoom v-groove never-hide" *ngIf="editingVGroove"
                 [style.background-image]="'url(' + project.vGrooveUrl(200) + ')'"
                 (click)="requestEdit($event, 'bottomMat')">
              <label>
                <mat-icon class="never-hide" svgIcon="information-outline" (click)="vGrooveInfo($event)"></mat-icon>
                V-Groove
              </label>
              <button class="top-right extra-small never-hide" color="tertiary" mat-mini-fab (click)="closeVGrooveEditWindow($event)">
                <mat-icon svgIcon="x"></mat-icon>
              </button>

              <mbnm-lazy-size-select [(ngModel)]="project.vGrooveOffset" [multiCharFractions]="true" label="V-Groove Offset"
                                     [range]="project.availableVGrooveOffsets ? project.availableVGrooveOffsets : defaultVGrooveOffsets" (change)="editingVGroove = false">
              </mbnm-lazy-size-select>

              <button class="extra-small never-hide remove-vgroove" color="tertiary" mat-flat-button
                      (click)="removeVGroove($event)">
                <mat-icon svgIcon="trash"></mat-icon> Remove
              </button>
            </div>
          </div>

          <mbnm-shape-selector #shapeSelector *ngIf="project && !project.permanentDesignId && project.openings.length === 1"
                               class="top-left" [project]="project" [pencilTrigger]="true"></mbnm-shape-selector>

          <button class="bottom-right extra-small" color="tertiary" mat-mini-fab (click)="rotateOpeningIfPossible($event)" *ngIf="!project.size.incomplete && !project.permanentDesignId && !project.design" style="margin-top:-6px">
            <mat-icon aria-label="rotate opening" svgIcon="rotate"></mat-icon>
          </button>

          <div class="label center" *ngIf="(opening.reveal > 0 && project.numMats == 2 || project.numMats < 2) && !opening.print">
            <mbnm-uploader (uploadComplete)="printUploadCompleted($event, opening)"
                           (uploadFailed)="printUploadFailed($event)"
                           [disclaimerAccepted]="project.hasPrint"
                           uploadPath="/print/"
                           acceptedFileTypes="image/*">
              <mat-icon svgIcon="image-upload"></mat-icon>
            </mbnm-uploader>
          </div>

          <button class="bottom-left inside extra-small" mat-mini-fab (click)="removePrint(opening)" color="tertiary" *ngIf="opening.print?.isUpload && project.numMats >= 0">
            <mat-icon aria-label="remove upload" svgIcon="trash" color="default"></mat-icon>
          </button>

          <div class="width" *ngIf="!opening.restrictions?.positionLocked" [ngClass]="{'shift': overlaps.controls.width, 'shift-out': overlaps.opening.width}"
               [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.openingWidth}">
            <mbnm-lazy-size-select [(ngModel)]="opening.size.width" label="Opening Width" placeholder="width"
                                   [standardSizesLink]="true" [range]="opening.size.widthRange" [project]="project"
                                   [disabled]="project.size.partiallyComplete" *ngIf="!project.permanentDesignId"
                                   [readonly]="showRotationRestrictions"
                                   [extraOptions]="[{value: 0, text: 'No Opening'}, {value: 0, text: '0&#8221;'}]" (change)="openingSizeDimensionChanged($event, 'width')"
                                   extraMessaging="<strong>Missing Opening Size?</strong><p>Try expanding your outer size to see if more opening sizes become available.</p><p>Max Opening Size is 30&#34; x 38&#34;.</p>"
                                   disabledMessaging="Please complete your outer size selection before choosing an opening size.">
            </mbnm-lazy-size-select>
            <div class="readonly-size"
                 [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.openingWidth}"
                 *ngIf="project.permanentDesignId">{{ opening.size.width | size | inches }}
            </div>
          </div>
          <div class="height" *ngIf="!opening.restrictions?.positionLocked" [ngClass]="{'shift': overlaps.controls.height, 'shift-out': overlaps.opening.height}"
               [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.openingHeight}">
            <mbnm-lazy-size-select [(ngModel)]="opening.size.height" label="Opening Height" placeholder="height"
                                   [standardSizesLink]="true" [range]="opening.size.heightRange" [project]="project"
                                   [disabled]="project.size.partiallyComplete" *ngIf="!project.permanentDesignId"
                                   [readonly]="showRotationRestrictions"
                                   [extraOptions]="[{value: 0, text: 'No Opening'}, {value: 0, text: '0&#8221;'}]" (change)="openingSizeDimensionChanged($event, 'height')"
                                   extraMessaging="<strong>Missing Opening Size?</strong><p>Try expanding your outer size to see if more opening sizes become available.</p><p>Max Opening Size is 30&#34; x 38&#34;.</p>"
                                   disabledMessaging="Please complete your outer size selection before choosing an opening size.">
            </mbnm-lazy-size-select>
            <div class="readonly-size"
                 [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.openingHeight}"
                 *ngIf="project.permanentDesignId">{{ opening.size.height | size | inches }}
            </div>
          </div>
          <div class="zoom reveal" *ngIf="project.numMats == 2 && idx == project.numOpenings - 1 && !project.permanentDesignId && !project.design"
               [style.width]="(opening.bigReveal ? 120 : 80) + 'px'"
               [style.height]="(opening.bigReveal ? 120 : 80) + 'px'"
               [style.top]="'calc(50% - ' + (opening.bigReveal ? 60 : 40) + 'px)'"
               [style.right]="(-project.reveal/sizeOrDefault(opening).width*50) + '%'"
               [style.margin-right]="(opening.bigReveal ? -60 : -40) + 'px'"
               [style.background-image]="'url(' + project.revealUrl(150) + ')'"
               (click)="requestEdit($event, 'bottomMat')">

            <mbnm-lazy-size-select [(ngModel)]="project.reveal" [multiCharFractions]="true" label="Reveal" placeholder="reveal"
                                   [range]="project.availableReveals">
            </mbnm-lazy-size-select>
            <button class="bottom-center extra-small" color="tertiary" mat-mini-fab (click)="requestEdit($event, 'bottomMat')">
              <mat-icon [svgIcon]="project.bottomMat ? 'pencil' : 'plus'"></mat-icon>
            </button>
          </div>
          <button class="center-right extra-small" mat-mini-fab color="tertiary" (click)="requestEdit($event, 'bottomMat')"
                  *ngIf="project.bottomMatAllowed && !project.design && !project.permanentDesignId && project.numMats < 2">
            <mat-icon [svgIcon]="project.bottomMat ? 'pencil' : 'plus'"></mat-icon>
          </button>

          <ng-container *ngIf="!project.permanentDesignId && project.sizesComplete">
            <div class="margin-label top"
                 [ngStyle]="{height: margins(opening).top, top: '-'+margins(opening).top}">
              <span>{{ project.centeredMargins.height - project.offset | size | inches }}</span>
            </div>
            <div class="margin-label side"
                 [ngStyle]="{width: margins(opening).left, left: '-'+margins(opening).left}">
              <span>{{ project.centeredMargins.width | size | inches }}</span>
            </div>

            <!-- REMOVE RIGHT SIDE MARGIN LABEL TO CLEAR SPACE
            <div class="margin-label side"
                 [ngStyle]="{width: margins(opening).right, right: '-'+margins(opening).right}">
              <span>{{ project.centeredMargins.width | size | inches }}</span>
            </div>
            -->

            <!-- START OF ADDING OFFSET TO PREVIEW (DEBATABLE IF WE WANT THIS)
            <div class="margin-label side v-groove-offset" *ngIf="project.vGrooveOffset && project.sizesComplete"
                 [ngStyle]="{width: margins(opening).right, right: '-'+margins(opening).right}">
              <span>{{ project.vGrooveOffset | size:'multichar' | inches }}</span>

              <button class="bottom-right extra-small" color="secondary-subtle" mat-mini-fab
                      (click)="vGroove($event)">
                <mat-icon svgIcon="pencil"></mat-icon>
              </button>
            </div>
            -->
          </ng-container>
        </div>
        }
        <div class="width" [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.outerWidth}">
          <mbnm-lazy-size-select [(ngModel)]="project.size.width" label="Outer Width" [standardSizesLink]="true"
                                 [range]="project.size.widthRange" placeholder="width" [project]="project"
                                 *ngIf="!project.permanentDesignId && !project.restrictions?.outerSizeLocked"
                                 [disabled]="project.numOpenings > 0 && project.opening.size.partiallyComplete"
                                 [readonly]="showRotationRestrictions"
                                 extraMessaging="<strong>Missing Outer Size?</strong><p>If you have an opening size, try shrinking it to see if additional outer sizes become available.</p><p>Max Outer Size is 32&#34; x 40&#34;.</p>"
                                 disabledMessaging="Please complete your opening size selection before choosing an outer size.">
          </mbnm-lazy-size-select>
          <div class="readonly-size" *ngIf="project.permanentDesignId || project.restrictions?.outerSizeLocked">{{ project.size.width | size | inches }}</div>
        </div>
        <div class="height" [ngClass]="{flash: showRotationRestrictions && project.rotationRestrictions?.outerHeight}">
          <mbnm-lazy-size-select [(ngModel)]="project.size.height" label="Outer Height" placeholder="height" [standardSizesLink]="true"
                                 [range]="project.size.heightRange" [project]="project"
                                 *ngIf="!project.permanentDesignId && !project.restrictions?.outerSizeLocked"
                                 [disabled]="project.numOpenings > 0 && project.opening.size.partiallyComplete"
                                 [readonly]="showRotationRestrictions"
                                 extraMessaging="<strong>Missing Outer Size?</strong><p>If you have an opening size, try shrinking it to see if additional outer sizes become available.</p><p>Max Outer Size is 32&#34; x 40&#34;.</p>"
                                 disabledMessaging="Please complete your opening size selection before choosing an outer size.">
          </mbnm-lazy-size-select>
          <div class="readonly-size" *ngIf="project.permanentDesignId || project.restrictions?.outerSizeLocked">{{ project.size.height | size | inches }}</div>
        </div>

        <div class="label bottom wide left-pad" *ngIf="!project.topMat && !project.hasPrint && (!simpleMode|| !editingVGroove)"
             [ngClass]="{center: project.size.incomplete}">
          tap for mats
          <ng-container *ngIf="project.primaryProduct == 'FRAME'">(optional)</ng-container>
        </div>

        <div class="bottom-margin" *ngIf="!project.permanentDesignId && !project.size.incomplete && project.numOpenings == 1 && !project.opening.size.incomplete && !project.openings[0].restrictions?.bottomMarginLocked"
             [style.height]="((project.size.height - sizeOrDefault(project.opening).height)/2 + project.offset)/project.size.height * 100 + '%'">
          <mbnm-lazy-size-select [(ngModel)]="project.bottomMargin" label="Bottom Margin" placeholder="margin"
                                 [range]="project.availableBottomMargins" [extraOptions]="project.specialBottomMargins">
          </mbnm-lazy-size-select>
        </div>

        <button *ngIf="project.primaryProduct === 'FRAME'" class="center-right extra-small" color="tertiary" mat-mini-fab (click)="requestEdit($event, 'topMat')">
          <mat-icon [svgIcon]="project.topMat ? 'pencil' : 'plus'"></mat-icon>
        </button>

        <div class="label center" style="z-index: 2" *ngIf="!project.design && project.numOpenings === 0 && project.primaryProduct === 'FRAME' && !project.print">
          <mbnm-uploader [disclaimerAccepted]="project.hasPrint"
                         [allowMultiple]="false"
                         (uploadComplete)="printUploadCompleted($event, null)"
                         (uploadFailed)="printUploadFailed($event)"
                         uploadPath="/print/"
                         acceptedFileTypes="image/*">
            <mat-icon svgIcon="image-upload"></mat-icon>
          </mbnm-uploader>
        </div>
        <button class="bottom-left inside extra-small" mat-mini-fab (click)="removePrint()" color="tertiary" *ngIf="project.print && project.numMats === 0 && project.primaryProduct === 'FRAME'">
          <mat-icon aria-label="remove upload" svgIcon="trash" color="default"></mat-icon>
        </button>
      </div>
      <div *ngIf="!project.design && project.numOpenings == 0 && project.primaryProduct == 'MAT'" class="add-opening-wrapper" (click)="addOpening($event)">
        <button mat-mini-fab>
          <mat-icon aria-label="Add Opening" svgIcon="add-opening"></mat-icon>
        </button>
      </div>
      <button class="bottom-right extra-small" color="tertiary" mat-mini-fab (click)="rotateOuterIfPossible($event)" *ngIf="!project.size.incomplete && !project.permanentDesignId && (!project.restrictions || project.restrictions.rotationLocked === false)">
        <mat-icon aria-label="rotate outer" svgIcon="rotate"></mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="controls" *ngIf="!showRotationRestrictions && !editingVGroove" [ngClass]="{'simple-mode': simpleMode, 'have-frame': project.moulding}">
  <a (click)="toggleMode($event)" *ngIf="project?.canPreview">
    {{ simpleMode ? 'show controls' : 'hide controls' }}
  </a>
</div>
